import React, { Component } from 'react'
import './App.css';
import Appbars from '../src/Appbars'
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Pageone from '../src/Pageone'

import Footer from '../src/Footer'
import About from '../src/footer/About'
import Blogs from '../src/footer/Blogs'
import Career from '../src/footer/Career'
import Community from '../src/footer/Community'
import Contactus from '../src/footer/Contactus'
import Faqs from '../src/footer/Faqs'
import Investers from '../src/footer/Investors'
import Media from '../src/footer/Media'
import Privacy from '../src/footer/Privacy'
import Terms_and_conditon from '../src/footer/Terms_and_conditon'
import Reports, { Reportsc } from './Reports';

const router = createBrowserRouter([

  {
    path: "/",
    element: <Pageone />,
  },
////////// footers
    {
    path: "/contact",
    element: <Contactus/>,
  },
  {
    path: "/blog",
    element: <Blogs/>,
  },
 
  {
    path: "/career",
    element: <Career/>,
  },
  
  {
    path: "/media",
    element: <Media/>,
  },
  {
    path: "/faq",
    element: <Faqs/>,
  },
  {
    path: "/about",
    element: <About/>,
  },
  {
    path: "/community",
    element: <Community/>,
  },
  {
    path: "/investors",
    element: <Investers/>,
  },
  {
    path: "/privacy",
    element: <Privacy/>,
  },

  {
    path: "/termsAndCondition",
    element: <Terms_and_conditon/>,
  },
  



{
    path: "/reports",
    element: <Reportsc/>,
  },
  

]);






function App() {

  return (
    <div>


     <React.StrictMode>
               <RouterProvider router={router} /> 
             </React.StrictMode>
                    
     

    </div>
  );
}

export default App;

